var global = require('../internals/global');

module.exports = global;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-app-polyfill/node_modules/core-js/internals/path.js
// module id = 314
// module chunks = 1